import { Code, ConnectError } from '@connectrpc/connect';

// Response headers set by the backend (backend/internal/infrastructure/observability/headers.go).
// They are only readable cross-origin because the API lists them in CORS ExposedHeaders.
export const REQUEST_ID_HEADER = 'X-Request-ID';
export const ERROR_CODE_HEADER = 'X-A6TR-Error-Code';

// Codes that reflect a normal business outcome or a user action rather than a defect, so they
// are not reported to Sentry.
const EXPECTED_CODES: ReadonlySet<Code> = new Set([
	Code.Canceled,
	Code.NotFound,
	Code.InvalidArgument,
	Code.FailedPrecondition,
	Code.AlreadyExists,
	Code.OutOfRange,
	Code.PermissionDenied,
	Code.Unauthenticated,
	Code.ResourceExhausted,
]);

export type ApiErrorDetails = {
	connectError: ConnectError;
	code: Code;
	codeName: string;
	requestId?: string;
	errorCode?: string;
};

export function getApiErrorDetails(error: unknown): ApiErrorDetails {
	const connectError = ConnectError.from(error);
	return {
		connectError,
		code: connectError.code,
		codeName: Code[connectError.code] ?? String(connectError.code),
		requestId: connectError.metadata.get(REQUEST_ID_HEADER) ?? undefined,
		errorCode: connectError.metadata.get(ERROR_CODE_HEADER) ?? undefined,
	};
}

export function isExpectedApiError(code: Code): boolean {
	return EXPECTED_CODES.has(code);
}
